<template>
  <span>
    <el-button icon=""
            style="padding:0 .1rem" size="small" type="text" @click="analysisDetailFlag = true;getList();"
      >任务详情</el-button
    >
    <el-dialog title="任务详情" 
    
    :close-on-click-modal="false"
    :visible.sync="analysisDetailFlag" append-to-body width="65%">
      <div style="">
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px">
            
              <el-row>
                  <el-col :span="8">
              <el-form-item label="项目名称：">
                <!-- <el-input v-model="formInline.projectId" :disabled="true" placeholder="项目名称"></el-input> -->
              
                <el-select
    clearable v-model="formInline.projectId" :disabled="true" placeholder="请选择项目名称">
                    <el-option 
                    v-for="(item,index) in projectList" 
                    :key="index"
                            :value="item.id"
                            :label="item.name"
                    >

                    </el-option>
                </el-select>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="填报部门：">
                <!-- <el-input v-model="formInline.user" :disabled="true" placeholder="项目名称"></el-input> -->
                
                <el-select
    clearable v-model="formInline.deptName" placeholder="请选择填报部门">
                    <el-option 
                    v-for="(item,index) in deptList" 
                    :key="index"
                            :value="item"
                            :label="item"
                    >

                    </el-option>
                </el-select>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="填报人员：">
                <el-input
    clearable v-model="formInline.userName" placeholder="请输入填报人员"></el-input>
              </el-form-item></el-col>
              </el-row>
              <el-row>
                  <el-col :span="8">
              <el-form-item label="提交时间：">


                
    <el-date-picker
    style="width:100%"
    clearable
    @blur="fillTimeChange"
      v-model="fillTime"
      type="datetimerange"
      :default-time="['00:00:00','23:59:59']"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="状态：">
                <el-select
    clearable v-model="formInline.finishFlag" @change="finishFlagChange" placeholder="请选择状态">
                    <el-option 
                    v-for="(item,index) in finishFlagList" 
                    :key="index"
                            :value="item.dictKey"
                            :label="item.dictValue"
                    >

                    </el-option>
                </el-select>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="完成情况：">
                <el-input v-model="formInline.performance"
    clearable :disabled="true" placeholder="请输入完成情况"></el-input>
              </el-form-item></el-col>
              </el-row>
              <el-row style="text-align:right;">
                    <el-form-item>
                  <div>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onSubmit">搜索</el-button>
                        <el-button type="default" size="small" icon="el-icon-delete" @click="onClear">清空</el-button>
                    
                </div>
                    </el-form-item>
              </el-row>
          </el-form>
        </div>
        <div>
          <!-- <el-button @click="handleClick(scope.row)" type="primary" size="small"
            >新增整改记录</el-button
          > -->
          任务明细
        </div>
        <div>
          <el-table 
          height="200"
          border
          :data="tableData">
            <el-table-column 
          align="center"
          header-align="center"
          label="#" type="index"> </el-table-column>
            <el-table-column prop="taskName" label="任务名称" width="280"> </el-table-column>
            <el-table-column prop="objectTypeName" label="考核对象" width="180"> </el-table-column>
            <el-table-column prop="totalScore" label="总分"> </el-table-column>
            <el-table-column prop="baseScore" label="基准分"> </el-table-column>
            <el-table-column prop="deptName" label="填报部门"> </el-table-column>
            <el-table-column prop="userName" label="填报人员"> </el-table-column>
            <el-table-column prop="fillScoreSum" label="考核得分"> 
              
              <template slot-scope="scope"><span 
                style="color:red;"
                v-if="(scope.row.fillScoreSum+'')&&(parseInt(scope.row.fillScoreSum)<parseInt(scope.row.baseScore))" 
                >{{scope.row.fillScoreSum}}</span><span
                  v-else
                >{{scope.row.fillScoreSum}}</span></template>
            </el-table-column>
            <el-table-column prop="finishFlag" label="状态"> 
                <template slot-scope="scope">
                    <span>{{getFinishFlagName(scope.row.finishFlag)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="fillTime" label="提交时间"> </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="详情" 
    :close-on-click-modal="false"
    :visible.sync="analysisListDetailFlag" append-to-body width="65%">

        <div>
          <el-form :inline="true" :model="infoForm" class="demo-form-inline" label-width="100px">
            
              <el-row>
                  <el-col :span="8">
              <el-form-item label="任务名称：">
                <el-input v-model="infoForm.taskName" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="考核对象：">
                <el-input v-model="infoForm.objectTypeName" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="任务状态：">
                <!-- <el-input v-model="infoForm.finishFlag" :disabled="true" placeholder="填报人员"></el-input> -->
                
                <el-select v-model="infoForm.finishFlag" style="width:100%;" :disabled="true" @change="finishFlagChange" placeholder="暂无">
                    <el-option 
                    v-for="(item,index) in finishFlagList" 
                    :key="index"
                            :value="item.dictKey"
                            :label="item.dictValue"
                    >

                    </el-option>
                </el-select>
              </el-form-item></el-col>
              </el-row>
              <el-row>
                  <el-col :span="8">
              <el-form-item label="填报部门：">
                <el-input v-model="infoForm.deptName" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="填报人员：">
                <el-input v-model="infoForm.userName" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="总分：">
                <el-input v-model="infoForm.totalScore" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
              </el-row>
              <el-row>
                  <el-col :span="8">
              <el-form-item label="基准分：">
                <el-input v-model="infoForm.baseScore" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="考核得分：">
                <el-input v-model="infoForm.fillScoreSum" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="提交时间：">
                <el-input v-model="infoForm.fillTime" :disabled="true" placeholder="暂无"></el-input>
              </el-form-item></el-col>
              </el-row>
          </el-form>
        </div>
        <div>
          <!-- <el-button @click="handleClick(scope.row)" type="primary" size="small"
            >新增整改记录</el-button
          > -->
考核项目

        </div>
          <el-table
          border
           :data="tableDataDetail"  height="250">
            <el-table-column 
          align="center"
          header-align="center"
            label="#" type="index"> </el-table-column>
            <el-table-column prop="content" label="标准内容" width="280"> </el-table-column>
            <el-table-column prop="demand" label="考核要求" width="180"> </el-table-column>
            <el-table-column prop="score" label="分值"></el-table-column>
            <el-table-column prop="baseScore" label="基准分值"> </el-table-column>
            <el-table-column prop="fillScore" label="实际得分"> 
              <template slot-scope="scope"><span 
                style="color:red;"
                v-if="(scope.row.fillScore+'')&&(parseInt(scope.row.fillScore)<parseInt(scope.row.baseScore))" 
                >{{scope.row.fillScore}}</span><span
                  v-else
                >{{scope.row.fillScore}}</span></template>
            </el-table-column>
            <el-table-column prop="description" label="描述"> </el-table-column>
          </el-table>
    </el-dialog>
  </span>
</template>

<script>

import { getAssessTaskListList,getSOLOTaskStandardDetail,getAllDeptNameByTaskId } from '@/api/v4ward/assess/task/assesstask';

        import { getDictionary } from '@/api/common';
        import {getProjectList} from "@/api/crmedical/group/group";

import dayjs from 'dayjs';
export default {
  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },
  data() {
    return {
        tableData:[],
        deptList:[],
            finishFlagList:[],
        tableDataDetail:[],
        analysisListDetailFlag:false,
      analysisDetailFlag: false,
          fillTime:[],
          projectList:[],
      formInline: {
          user: '',
          region: '',
        },
        infoForm:{},
    };
  },
  methods: {
      getFinishFlagName(finishFlag){
          let finishFlagName = '';
          this.finishFlagList.forEach((ele)=>{
            if(ele.dictKey+'' === finishFlag+''){
                finishFlagName = ele.dictValue;
            }
          });
          return finishFlagName;
      },
      getList(){
          this.formInline = this.row;
          
          this.fillTime=[],
        getProjectList().then((res)=>{
            
        this.projectList = res.data;
        });
      getDictionary('assess_task_list_finish_flag').then((res)=>{
          this.finishFlagList = res.data;
      });
      let taskId = this.row.id;
      getAllDeptNameByTaskId({taskId:taskId}).then((res)=>{
          this.deptList = res.data;
      });
        this.searchList();
      },
    handleClick(row) {
      console.log(row);
      this.analysisListDetailFlag = true;
      this.infoForm = row;
      let taskId = this.row.id;
      this.infoForm.finishFlag = this.infoForm.finishFlag+'';
      getSOLOTaskStandardDetail({taskId:taskId,taskListId:row.id}).then((res)=>{
          this.tableDataDetail = res.data;
      });
    }, 
    searchList(){
        console.log("this.formInline.fillTime====>",this.fillTime);
        if(this.fillTime&&this.fillTime.length>1){
            this.formInline.timeStart = dayjs(this.fillTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.formInline.timeEnd = dayjs(this.fillTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }else{

            this.formInline.timeStart = '';
            this.formInline.timeEnd = '';
        }
      let taskId = this.row.id;
          let projectId = this.row.projectId;
          getAssessTaskListList({
              taskId:taskId,
              projectId:projectId,
              userName:this.formInline.userName,
              deptName:this.formInline.deptName,
              finishFlag:this.formInline.finishFlag,
              timeStart:this.formInline.timeStart,
              timeEnd:this.formInline.timeEnd
              
              }).then((res)=>{
              this.tableData = res.data;
          });
    },
    onSubmit() {
        this.searchList();
    },
    finishFlagChange(val){
        this.formInline = Object.assign({},this.formInline,{
            finishFlag:val
        });
    },
    // fillTimeChange(val){

    //     console.log(val.valueOnOpen);
    //     this.fillTime = val.valueOnOpen
    // },
    onClear(){
        this.fillTime=[],

        this.formInline.finishFlag='',
        this.formInline.deptName='',
        this.formInline.userName='',
        this.searchList();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
    width:calc(100% - 100px);
}
::v-deep .el-form-item {
    width:100%;
}

</style>